import { FilterMatchMode, FilterOperator } from "primereact/api";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toolbar } from "primereact/toolbar";
import { InputText } from "primereact/inputtext";
import AddEventGroup from "../componets/AddEventGroup";
import EventGroupService from "../services/EventGroupService";
import { Dialog } from "primereact/dialog";
import { TabPanel, TabView } from "primereact/tabview";
import { InputTextarea } from "primereact/inputtextarea";
import TextInput from "../componets/TextInput";
import { eventService } from "../services/EventService";
import { EventsTree } from "../pages/EventsTree";
import { AppDB } from "../App";
import { formatDate } from "../config/Config";
import { BreadCrumb } from "primereact/breadcrumb";
import { permissionLookUp } from "./../constants";

export const EventGroup = () => {
	const [showAddEventGroupForm, setShowAddEventGroupForm] = useState(false);
	const [showDialog, setShowDialog] = useState(false);
	const [editDialog, seEditDialog] = useState(false);
	const [loading, setLoading] = useState(false);
	let [data, setData] = useState([]);
	const [showEvents, setShowEvents] = useState(false);

	const [selectedEventGroup, setSelectedEventGroup] = useState(null);
	const [showEditForm, setShowEditForm] = useState(false);
	const [showEditEventGroup, setshowEditEventGroup] = useState(false);
	const [editInput, setEditInput] = useState("");
	const { setgroupEventInfo, toast, permission } = useContext(AppDB);

	useEffect(() => {
		if (selectedEventGroup !== null) {
			setgroupEventInfo(selectedEventGroup);
		}
	}, [selectedEventGroup, setgroupEventInfo]);

	function EventGroupDetails() {
		return [
			{
				name: "EventGroup Name:",
				value: selectedEventGroup?.name
			},
			{
				name: "EventGroup Description:",
				value: selectedEventGroup?.description
			},
			{
				name: "Status reason:",
				value: selectedEventGroup?.statusReason
			}
		];
	}
	const header = (
		<div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
			<h5 className="m-0">Event Groups</h5>
		</div>
	);

	var eventGroupService = new EventGroupService();
	useEffect(() => {
		GetAllEventGrops();
	}, []);

	async function GetAllEventGrops() {
		setLoading(true);
		await eventService
			.getAllGroups()
			.then((data) => {
				setData(data);
				setLoading(false);
			})
			.catch((err) => {
				setLoading(false);
			});
	}
	const [globalFilterValue, setGlobalFilterValue] = useState("");
	const [filters, setFilters] = useState({
		global: { value: null, matchMode: FilterMatchMode.CONTAINS },
		name: {
			operator: FilterOperator.AND,
			constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
		}
	});

	const onGlobalFilterChange = (e) => {
		const value = e.target.value;
		let _filters1 = { ...filters };
		_filters1["global"].value = value;
		setFilters(_filters1);
		setGlobalFilterValue(value);
	};

	async function onEditHandler() {
		try {
			await eventService
				.editGroup(selectedEventGroup)
				.then((res) => {
					toast.show({
						severity: res?.success ? "success" : "error",
						summary: "Success Message",
						detail: res?.message,
						life: 2000
					});

					if (res?.success) {
						GetAllEventGrops();
					}
					setshowEditEventGroup(!res?.success);
				})
				.catch((error) => {
					return toast.show({
						severity: "error",
						detail: "Something went wrong.",
						life: 2000
					});
				});
		} catch (err) {
			return toast.show({
				severity: "error",
				summary: "Success Message",
				detail: "Something went wrong.",
				life: 2000
			});
		}
	}

	function onEditHandaler() {
		eventGroupService.updateEventGroup(selectedEventGroup).then((response) => {
			console.log(response);
			eventGroupService.getAllEventGroups().then((data) => {
				console.log(data);
				setData(data);
				setshowEditEventGroup(false);
				return toast.show({
					severity: "success",
					summary: "Success Message",
					detail: "Event Group was updated successfully",
					life: 2000
				});
			});
		});
	}

	function activateHandler(id) {
		eventGroupService.activateEventGroup(id).then((res) => {
			eventGroupService.getAllEventGroups().then((data) => {
				console.log(data);
				setData(data);
			});
		});
	}

	async function deActivateHandler() {
		setLoading(true);
		if (editInput.trim().length == 0)
			return toast.show({
				severity: "error",
				summary: "Error Message",
				detail: "Please fill the required field",
				life: 3000
			});
		var id = selectedEventGroup?.EventGroupID;
		var payload = {
			EventGroupID: selectedEventGroup?.eventGroupID,
			StatusReason: editInput
		};

		await eventService
			.deleteGroup(payload)
			.then((res) => {
				setLoading(false);

				if (res?.success) {
					GetAllEventGrops();
					setShowEditForm(false);
				}
				return toast.show({
					severity: res?.success ? "success" : "error",
					summary: "Message",
					detail: res?.message,
					life: 2000
				});
			})
			.catch((err) => {
				setLoading(false);

				return toast.show({
					severity: "error",
					summary: "Message",
					detail: "Something went wrong while deleteting the group.",
					life: 2000
				});
			});
	}
	async function GetEventGroupById(id) {
		await eventService
			.GetEventGroupByID(id)
			.then((res) => {
				setLoading(false);

				if (res?.success) {
					setLoading(false);
					setSelectedEventGroup(res?.data);
				} else {
					return toast.show({
						severity: res?.success ? "success" : "error",
						summary: "Message",
						detail: res?.message,
						life: 2000
					});
				}
			})
			.catch((err) => {
				setLoading(false);

				return toast.show({
					severity: "error",
					summary: "Message",
					detail: "Something went wrong while fetching event group.",
					life: 2000
				});
			});
	}

	const [selectedTopicUrl, setSelectedTopicUrl] = useState("");

	return (
		<div className="card  p-align-stretch vertical-container">
			<h5>Event Groups</h5>
			<div className="">
				<div className="grid  relative my-2">
					<div className=" col-span-1 ">
						{permission?.actions?.includes(permissionLookUp.Create) && (
							<Button
								className=" left-0 p-button-success mr-2"
								icon="pi pi-plus"
								label="Add Event Group"
								onClick={(e) => setShowAddEventGroupForm(true)}
							/>
						)}
					</div>

					<div className="right-0  col-span-2">
						<span className="block mt-2 md:mt-0 p-input-icon-left">
							<i className="pi pi-search" />
							<InputText
								value={globalFilterValue}
								onChange={onGlobalFilterChange}
								placeholder="Search By Event Group Name"
								tooltip="Search By Event Group Name"
							/>
						</span>
					</div>
				</div>
			</div>
			<Dialog
				draggable={false}
				header={
					<>
						<li className="pi pi-eye"> </li>
						<span> Event Group Details</span>
					</>
				}
				visible={showDialog}
				style={{ width: "50%", height: "50%" }}
				modal
				onHide={(e) => {
					setShowDialog(false);
				}}
			>
				<TabView>
					<TabPanel header="Event Group Details">
						<DataTable
							size="small"
							scrollable={true}
							value={EventGroupDetails() || []}
							dataKey="id"
							responsiveLayout="scroll"
							resizableColumns
						>
							<Column style={{ width: "100px" }} field="name" body={(e) => <b>{e?.name}</b>}></Column>
							<Column field="value"></Column>
						</DataTable>
					</TabPanel>
				</TabView>
			</Dialog>

			<Dialog
				header="Event Group Details"
				visible={showEditForm}
				style={{ width: "50%", height: "50%" }}
				modal
				onHide={(e) => {
					setShowEditForm(false);
				}}
			>
				<div className="grid">
					<div className="col-12">
						<label>
							Reason for <b> {selectedEventGroup?.name}</b>
						</label>
					</div>
					<div className="col-12">
						<InputTextarea value={editInput} style={{ width: "100%" }} onChange={(e) => setEditInput(e.target.value)} />
					</div>
					<div className="col-12">
						<Button className="p-button-success" label="Submit" onClick={deActivateHandler} />
					</div>
				</div>
			</Dialog>
			<Dialog
				draggable={false}
				header="Edit Event Group"
				footer={
					<>
						<Button label="Submit" onClick={onEditHandler} className="p-button-success" icon="pi pi-plus" type="submit" />
					</>
				}
				visible={showEditEventGroup}
				style={{ width: "50%", height: "50%" }}
				modal
				onHide={(e) => {
					setshowEditEventGroup(false);
				}}
			>
				<div className="grid">
					<div className="col-12  lg:col-6">
						<TextInput
							label="Name"
							value={selectedEventGroup?.name}
							onChange={(e) => setSelectedEventGroup({ ...selectedEventGroup, name: e.target.value })}
						/>
					</div>
					<div className="col-12  lg:col-6">
						<TextInput
							label="Description"
							value={selectedEventGroup?.description}
							onChange={(e) => setSelectedEventGroup({ ...selectedEventGroup, description: e.target.value })}
						/>
					</div>
				</div>
				{/* <TextInput label="Reason" value={selectedEventGroup?.StatusReason} disabled ={true} /> */}
			</Dialog>
			<Dialog
				visible={showEvents}
				onHide={() => setShowEvents(false)}
				modal
				style={{ width: "95vw", height: "98vh" }}
				header={`Event Group - ${selectedEventGroup?.name}`}
				footer={
					<>
						<Button className="p-button-danger" type="button" label="Close" onClick={() => setShowEvents(false)} />
					</>
				}
			>
				<EventsTree
					selectedEventGroup={selectedEventGroup}
					setSelectedEventGroup={setSelectedEventGroup}
					RefreshSelectedEventGroup={GetEventGroupById}
					showEvents={showEvents}
					setShowEvents={setShowEvents}
				/>
			</Dialog>
			<AddEventGroup show={showAddEventGroupForm} setShow={setShowAddEventGroupForm} ReloadEventGroups={GetAllEventGrops} />

			<DataTable
				size="small"
				scrollable={true}
				value={data}
				dataKey="id"
				paginator
				rows={5}
				rowsPerPageOptions={[5, 10, 25]}
				className="datatable-responsive"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} users"
				emptyMessage="No event group found."
				// header={header}
				responsiveLayout="scroll"
				selection={selectedEventGroup}
				onSelectionChange={(e) => setSelectedEventGroup(e.value)}
				resizableColumns
				columnResizeMode="expand"
				filters={filters}
				filterDisplay="name"
				globalFilterFields={["name"]}
				loading={loading}
			>
				<Column field="name" header="Name" sortable className=""></Column>
				<Column field="description" header="Description" sortable></Column>

				<Column
					field="active"
					header="Status"
					body={(e) =>
						parseInt(e.status) == 1 ? (
							<Button label="Active" style={{ textAlign: "center", height: "30px" }} className="p-button-success p-button-rounded" />
						) : (
							<Button label="Not Active" style={{ textAlign: "center", height: "30px" }} className="p-button-danger p-button-rounded" />
						)
					}
				></Column>
				<Column
					field="actions"
					header="Actions"
					body={(e) => (
						<>
							{permission?.actions?.includes(permissionLookUp.Update) && (
								<Button
									disabled={parseInt(e.status) == 0}
									style={{ textAlign: "center", width: "30px", height: "30px" }}
									icon={"pi pi-pencil"}
									className="p-button-primary p-button-rounded mr-2 "
									tooltip="Click to Edit"
									onClick={(a) => {
										setshowEditEventGroup(true);
										setSelectedEventGroup(e);
									}}
								/>
							)}
							{permission?.subModules?.Event?.includes(permissionLookUp.Read) && (
								<Button
									style={{ textAlign: "center", width: "30px", height: "30px" }}
									icon="pi pi-cog"
									className="p-button-primary p-button-rounded mr-2 "
									tooltip="Click to configure group"
									onClick={() => {
										setShowEvents(true);
										setSelectedEventGroup(e);
									}}
								/>
							)}
							{permission?.actions?.includes(permissionLookUp.Delete) && (
								<Button
									disabled={parseInt(e.status) == 0}
									onClick={(a) => {
										setShowEditForm(true);
										setSelectedEventGroup(e);
									}}
									style={{ textAlign: "center", width: "30px", height: "30px" }}
									icon={"pi pi-times"}
									className="p-button-danger p-button-rounded mr-2"
									tooltip={e.status == 1 ? "Click to De-Activate" : "Click to Activate"}
								/>
							)}
						</>
					)}
				></Column>
			</DataTable>
		</div>
	);
};
